import { useSelector } from "react-redux";
import { RootState } from "../store";
import {
  selectIsAdvisorSession,
  selectIsAssociationSession,
} from "../store/auth-slice";
import { resolveDefaultRoute } from "../utils/defaultRoute";

/** ITAM-2887: the one landing route, shared by App and every internal redirect. */
export const useDefaultRoute = (): string => {
  const isPharmacist = useSelector(
    (state: RootState) => state.auth.isPharmacist,
  );
  const isAdvisor = useSelector(selectIsAdvisorSession);
  const isAssociation = useSelector(selectIsAssociationSession);

  return resolveDefaultRoute({ isPharmacist, isAdvisor, isAssociation });
};
